//Components
import { DialogerHeader } from './DialogerHeader.element';
// Types
import { ComponentsMap, DialogerProps } from './Dialoger.types';

/**
 * The `Dialoger` component represents a dialog with customizable content.
 *
 * @component
 * @param {DialogerProps} props - The component props.
 * @param {boolean} props.isOpen - Determines whether the dialog is open or closed.
 * @param {function} props.onClose - Callback function to close the dialog.
 * @param {string} props.dialogerType - Specifies the type of dialog, either 'drawer' or 'modal'.
 * @param {DialogerSetup} props.dialogerSetup - Configuration object for the dialog.
 * @returns {ReactElement} - The `Dialoger` component.
 */
export const Dialoger = ({ isOpen, onClose, dialogerType, dialogerSetup }: DialogerProps) => {
  const { Component, OverlayComponent, ContentComponent, HeaderComponent, BodyComponent } = ComponentsMap[dialogerType];

  const { isFullHeight = false, placement = 'bottom', header, body } = dialogerSetup;

  return (
    <Component
      isOpen={isOpen}
      onClose={onClose}
      placement={placement}
      isFullHeight={isFullHeight}
      isCentered
      motionPreset='slideInBottom'
      portalProps={{
        appendToParentPortal: false,
      }}
      variant={placement}
    >
      <OverlayComponent />
      <ContentComponent>
        <HeaderComponent p={4} maxH={16}>
          <DialogerHeader onClose={onClose}>{header}</DialogerHeader>
        </HeaderComponent>
        <BodyComponent p={0}>{body}</BodyComponent>
      </ContentComponent>
    </Component>
  );
};
